import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=88774ec4&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=88774ec4&prod&lang=css"
import style1 from "./CustomerDashboard.vue?vue&type=style&index=1&id=88774ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88774ec4",
  null
  
)

export default component.exports